/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "mouseenter", "mouseleave", "focusout"];
    this.touchStartY = 0;
    this.touchEndY = 0;
    this.touchThreshold = 10;
    if (!this.toggleCTA) return; // missing toggle
    this.init();
  }

  init() {
    if ('ontouchstart' in window) {
      this.dropdown.addEventListener('touchstart', (evt) => {
        this.touchStartY = evt.touches[0].clientY;
      });

      this.dropdown.addEventListener('touchend', (evt) => {
        this.touchEndY = evt.changedTouches[0].clientY;
        const touchDiff = Math.abs(this.touchEndY - this.touchStartY);
        if (touchDiff < this.touchThreshold && evt.target.closest('.dropdown-toggle')) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          this.toggleDropdown(evt);
        }
      });
    }

    this.supportedEvents.forEach((type) => {
      if (type === 'click') {
        this.toggleCTA.addEventListener(type, (evt) => {
          evt.preventDefault();evt.stopImmediatePropagation();
          let a_Tag = evt.target.closest('a');
          if(a_Tag && a_Tag.href != "#"){
            window.location.href = a_Tag.href;
          }
          this.toggleDropdown(evt);
        });
      } else if(type === 'mouseenter') {
        this.toggleCTA.addEventListener(type, (evt) => {
          evt.stopImmediatePropagation();
          let navElement = evt.target.closest('nav');
          if(navElement.classList.contains('navbar-mobile'))return;
            this.dropdownShow(this.dropdown);
           // Skip if the dropdown has gfr class
            if (this.dropdown.querySelector('.dropdown-menu--gfr')) return;
            const firstSubmenuItem = this.dropdown.querySelector('.dropdown-menu--submenu > .nav-item');
            if (firstSubmenuItem) {
              const submenu = firstSubmenuItem.querySelector('.dropdown-menu');
              const mainMenu = firstSubmenuItem.closest('.dropdown-menu--main');
              if (submenu && mainMenu) {
                // Set height based on first submenu content
                const height = submenu.offsetHeight;
                mainMenu.style.height = `${height + 50}px`;
                mainMenu.style.setProperty('--menu-height', `${height + 50}px`);
                // Add first-open class to first item
                firstSubmenuItem.classList.add('first-open');
              }
            }
        });
       

         
          this.toggleCTA.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdown);
        });
        document.querySelectorAll(".dropdown-menu--submenu li:not(.h5)").forEach((menuItem) => {
          menuItem.addEventListener(type, function (evt) {
            this.closest("ul").querySelectorAll("li:not(.h5)").forEach((allMenu) => {
              allMenu.classList.remove("first-open");
            });
            this.classList.add("first-open"); // now works correctly
          });
          }); 
      } else if(type === 'mouseleave') {
        this.dropdown.addEventListener(type, (evt) => {
           let navElement = evt.target.closest('nav');
          if(navElement.classList.contains('navbar-mobile'))return;
          this.dropdownHide(this.dropdown,'mouseleave');
        });
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
           let navElement = evt.target.closest('nav');
          if(navElement.classList.contains('navbar-mobile'))return;
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown,'focusout');
          }
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.close-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();evt.stopImmediatePropagation();
        this.toggleDropdown(evt);
      });
    }
  }

  toggleDropdown(evt) {
    let dropdownParent = evt.currentTarget.closest('[is="drop-down"]');
    this.dropdownToggle(dropdownParent);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent, 'dropdownToggle')
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent,from='none') {

    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
    document.querySelectorAll(".predictive-search").forEach((target) => {
      target.classList.remove("show-results");
    });
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container.querySelector('[data-trigger-video]');

    this.bindEvents();
  }

  connectedCallback() {
    // Connected callback
  }

  // Clean up event listeners
  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        if (this.placementType === 'popup') {
          this.openModal(this.videoModal, this.triggerVideo);
        } else {
          this.container.classList.add('playing--video');
        }
        this.videoSection.setAttribute('aria-hidden', 'false');
        if (this.placementType !== 'popup') this.pauseOnVisibilityChange(videoElement);
        this._playVideo(videoElement);
      }, 700);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&muted=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    const scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        scrollObserver.disconnect();
        return;
      }

      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
         this._pauseVideo(videoEle)
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  openModal(modal, opener){
    if(modal && opener != undefined) modal.show(opener);
  }
}
customElements.define("custom-video", CustomVideo);


/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
    this.videoContainer = this.querySelector('.video-container');
    if (this.videoContainer && this.classList.contains('promotional-video-modal')) {
      this.initialVideoContent = this.videoContainer.innerHTML;
    }

    // Prevent clicks inside modal from bubbling to drawer
    this.modal?.addEventListener('click', (evt) => {
      evt.stopPropagation();
    });
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.hide(evt);
      });
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) {
        evt.stopPropagation();
        this.hide(evt);
      }
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') {
        evt.stopPropagation();
        this.hide(evt);
      }
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);
    
    const pdpStickyEl = document.querySelector('.pdp-sticky');
    if (pdpStickyEl) {
      pdpStickyEl.classList.add('size-modal-open');
    }
    
    if (this.classList.contains('promotional-video-modal') && this.videoContainer) {
      if (!this.videoContainer.innerHTML) {
        this.videoContainer.innerHTML = this.initialVideoContent;
      }
      this.querySelector('video').setAttribute('autoplay','true');
    }

    // Skip overlay for size chart button in product page
    const productPageWrapper = opener?.closest('.pdp-sticky .variant-section-wrapper');
    const isModalOpen = productPageWrapper?.querySelector('#sizechart-popup .modal.open');
    if (!productPageWrapper || !isModalOpen) {
      SiteOverlay.prototype.showOverlay();
    }
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide(event) {
    if (event) {
      event.stopPropagation();
    }
    
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    const pdpStickyEl = document.querySelector('.pdp-sticky');
    if (pdpStickyEl) {
      pdpStickyEl.classList.remove('size-modal-open');
    }

    // Only hide overlay if no drawers are open
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    if(openDrawers.length === 0){
      SiteOverlay.prototype.hideOverlay();
    }

    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video' || this.classList.contains('promotional-video-modal')) this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn =>{
      btn.removeEventListener('click', this.closeDrawer.bind(this));
    })
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
 
        evt.preventDefault();
        if(btn.dataset.for == 'collection-sorting'){
          this.classList.add('collection-sorting');
          setTimeout(() => {
            (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
          }, 500);
        }else{
          (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
        }
        
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    if (window.innerWidth > 992) {
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.focusOut.bind(this));
    }
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(evt) {
    if(evt.code && evt.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

// openDrawer(opener) {
//   console.log('openDrawer', opener) ;
//   if(window.globalSpace.templateSuffix == 'waste-management-2025' && opener.closest('[data-product-container]')){
//     let productContainer =   opener.closest('[data-product-container]');
//     //console.log('waste-management-2025' , productContainer) ;
//     let variantSelector = productContainer.querySelector('[data-selectcontainer]');
//     if (variantSelector && variantSelector.querySelector('.selected')) {
//       console.log('waste-management-2025' , variantSelector) ;
//       let selectedOption = variantSelector.querySelector('.selected');
//       if(selectedOption.hasAttribute('default-selected')){
//        console.log('default-selected') ;
//        let selectBox = selectedOption.closest('.select');
//        if(selectBox){
//         selectBox.classList.add('error-please-select');
//         setTimeout(()=>{
//           selectBox.classList.remove('error-please-select');
//         },2400);
//        }
//         return;
//       }
//     }
      
//   }
//   this.resetOtherDrawers();
//   this.isOpen = true;
//   this.openedBy = opener || null;
//   this.classList.add('open');
//   this.setAttribute('aria-hidden', 'false');
//   this.openedBy?.setAttribute('aria-expanded', true);

//   if (!(this.id === 'mobile-nav-drawer' && document.body.id.includes('gfr-content'))) {
//     SiteOverlay.prototype.showOverlay();
//   }
//   document.body.classList.add('scroll-fixed');
//   Utility.trapFocus(this, this.forceFocus);
//   Utility.forceFocus(this.forceFocus);
// }

validateVariantSelection(opener) {
  if (
    !window.globalSpace ||
    window.globalSpace.templateSuffix !== "waste-management-2025" ||
    !opener?.closest
  ) return true; // ✅ allow opening if not waste-management template

  const productContainer = opener.closest("[data-product-container]");
  const variantSelector  = productContainer?.querySelector("[data-selectcontainer]");
  const selectedOption   = variantSelector?.querySelector(".selected");

  if (selectedOption?.hasAttribute("default-selected")) {
    const selectBox = selectedOption.closest(".select");
    if (selectBox) {
      selectBox.classList.add("error-please-select");
      setTimeout(() => selectBox.classList.remove("error-please-select"), 2400);
    }
    return false; // ❌ block drawer opening
  }

  return true; // ✅ safe to open drawer
}

openDrawer(opener) {
  try {
    // ✅ Block drawer if validation fails
    if (!this.validateVariantSelection(opener)) return;

    // ✅ Drawer logic
    this.resetOtherDrawers();
    this.isOpen = true;
    this.openedBy = opener || null;

    this.classList.add("open");
    this.setAttribute("aria-hidden", "false");
    this.openedBy?.setAttribute("aria-expanded", "true");

    if (!(this.id === "mobile-nav-drawer" && document.body.id.includes("gfr-content"))) {
      SiteOverlay.prototype.showOverlay();
    }

    document.body.classList.add("scroll-fixed");
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);

  } catch (err) {
    console.error("🚨 Error in openDrawer:", err);
  }
}


closeDrawer() {
    this.isOpen = false;
    this.classList.remove('open');
    this.setAttribute('aria-hidden', 'true');
    this.openedBy?.setAttribute('aria-expanded', false);
    setTimeout(() => {
      this.classList.remove('collection-sorting');
    }, 1000);

    if (!(this.id === 'mobile-nav-drawer' && document.body.id.includes('gfr-content'))) {
      SiteOverlay.prototype.hideOverlay();
    }
    document.body.classList.remove('scroll-fixed');
    Utility.removeTrapFocus(this.openedBy);
    this.openedBy = null;
    if(document.querySelector(".navbar-mobile-slide").querySelectorAll(".open").length > 0){
      document.querySelector(".navbar-mobile-slide").querySelectorAll(".open").forEach((target) => {
        target.classList.remove("open");
      });
    } 
}

resetOtherDrawers(){
  const openDrawers = document.querySelectorAll('custom-drawer.open');
  openDrawers.forEach(drawer => {
    drawer.closeDrawer();
  });
  
}
}
customElements.define('custom-drawer', CustomDrawer);



const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});


if(document.querySelectorAll("#customerLoginFor-time").length){
  const InputEmail = document.querySelector('#gfr-email');
  const InputPass = document.querySelector('#gfe-password');
  const submitBtn = document.querySelector('.block__form-login');

  function checkFields() {
    if (InputEmail.value.trim() === '' || InputPass.value.trim() === '') {
      submitBtn.disabled = true;
    } else {
      submitBtn.disabled = false;
    }
  }
  InputEmail.addEventListener('input', checkFields);
  InputPass.addEventListener('input', checkFields);
}

const navItems = document.querySelectorAll('.dropdown-menu--submenu > .nav-item');
navItems.forEach(item => {
  const submenu = item.querySelector('.dropdown-menu');
  const mainMenu = item.closest('.dropdown-menu--main');
  item.addEventListener('mouseenter', () => {
   if (!submenu) {
       mainMenu.style.height = `auto`;
      return;
   }

    const wasHidden = getComputedStyle(submenu).display === 'none';
    const originalStyles = {
      display: submenu.style.display,
      visibility: submenu.style.visibility,
      position: submenu.style.position,
    };
    if (wasHidden) {
      submenu.style.display = 'block';
      submenu.style.visibility = 'hidden';
      submenu.style.position = 'absolute';
    }
    mainMenu.style.height = '';
    const height = submenu.offsetHeight;
    if (wasHidden) {
      submenu.style.display = originalStyles.display;
      submenu.style.visibility = originalStyles.visibility;
      submenu.style.position = originalStyles.position;
    }
    mainMenu.style.height = `${height + 50}px`;
  });

});

document.addEventListener('DOMContentLoaded', () => {
  const dropdownLists = document.querySelectorAll('.more-sports .dropdown-menu');
  dropdownLists.forEach(dropdownList => {
      const parentContainer = dropdownList.closest('.megamenu'); // Find the closest parent with this class
      if (parentContainer) {
          dropdownList.addEventListener('mouseenter', () => {
              parentContainer.classList.add('hovered-parent');
          });
          dropdownList.addEventListener('mouseleave', () => {
              parentContainer.classList.remove('hovered-parent');
          });
      }
  });
});


// JS for megamenu height adjustment
window.addEventListener("load", () => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  if (screenWidth > 1200 && screenHeight < 900) {
    document.querySelectorAll(".desktop-navbar .navbar-nav > .megamenu > .dropdown-menu")
      .forEach(menu => {
        menu.classList.add("small-height");
      });
  }
});

customElements.define('complementary-variant-select', class extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init(){
    this.productData = JSON.parse(this.querySelector('script[type="text/json"]').textContent);
    this.dataParents = this.querySelectorAll('[data-option-parent]');
    this.formId = this.getAttribute('data-form-id');
    this.form = document.getElementById(this.formId);
    this.options = this.productData.options;
    this.selectOptionsWrapper = this.form.querySelector('[data-select-options]');
    this.selectOptionsButton = this.selectOptionsWrapper.querySelector('button');
    this.addToCartWrapper = this.form.querySelector('[data-add-to-cart]');
    this.addCartButton = this.form.querySelector('[data-add-to-cart] button');
    this.selectOptionsContent = this.form.querySelector('.complementary-variant-select__content');
    this.ClosePopUp = this.selectOptionsWrapper.querySelector('.closePairPopup');
    
    this.checkAndUpdateVariantAvailability();
    this.updateColorSwatches();

    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', (evt) => {
        console.log(evt.target.value);
        const optionIndex = evt.target.closest('[data-option-parent]').dataset.optionIndex = evt.target.dataset.optionIndex;
        this.getCurrentVariant();
        this.onVariantChange();
        this.checkAndUpdateVariantAvailability();
      });
    });
    this.selectOptionsButton.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      this.selectOptionsContent.classList.toggle('active');
      this.addToCartWrapper.classList.toggle('d-none');
      this.selectOptionsWrapper.classList.toggle('d-none');
    });
    console.log(this.selectOptionsButton, 'this.ClosePopUpthis.ClosePopUpthis.ClosePopUpthis.ClosePopUp');
    document.querySelectorAll(".closePairPopup").forEach(each=>{
      each.addEventListener("click", function(evt){
         evt.preventDefault();
      evt.stopPropagation();
        each.closest('.complementary-variant-select__content').classList.remove('active')
           each.closest('form').querySelector('[data-add-to-cart]').classList.add('d-none')
           each.closest('form').querySelector('[data-select-options]').classList.remove('d-none')
      })
    })
  }

  getCurrentVariant(){ 
    let selectedOptions = [];
    this.dataParents.forEach(parent => {
      const selectedInput = parent.querySelector('input[type="radio"]:checked');
      if(selectedInput){
        selectedOptions.push(selectedInput.value);
      }
    });
    let selectionOptionTitlte = selectedOptions.join(' / ');
    console.log(selectionOptionTitlte);
    this.selectedOptions = selectedOptions;
    this.productData.variants.forEach(variant => {
      if(variant.title.toLowerCase() == selectionOptionTitlte.toLowerCase()){
        this.currentVariant = variant;
        this.form.querySelector('input[name="id"]').value = variant.id;
        this.form.querySelector('[data-add-to-cart]').querySelector('button').classList.remove('disabled')
        this.form.querySelector('[data-add-to-cart]').querySelector('button').removeAttribute('disabled')
      }
    });
    return this.currentVariant;
  }

  onVariantChange(){
    if(this.currentVariant && this.currentVariant.available){
      this.addCartButton.querySelector('[data-add-to-cart-text]').textContent = '+ Add To Cart';
      this.addCartButton.disabled = false;
    }else if(this.currentVariant){
      this.addCartButton.querySelector('[data-add-to-cart-text]').textContent = 'Sold Out';
      this.addCartButton.disabled = true;
    }
  }

  updateColorSwatches() {
    const colorSwatchContainer = this.querySelector('.promo-size-row');
    if (!colorSwatchContainer || typeof Utility === 'undefined' || typeof Utility.getSwatchStyle !== 'function') return;
    const swatchListEl = document.querySelector('[data-swatches-colorlist-json]');
    if (!swatchListEl) return;
    const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
    colorSwatches.forEach(swatch => {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input || !input.dataset.handle) return;
      const swatchStyle = Utility.getSwatchStyle(input.dataset.handle);
      if (swatchStyle) {
        const label = swatch.querySelector('.swatch-label');
        if (label) label.setAttribute('style', swatchStyle);
      }
    });
  }

  checkAndUpdateVariantAvailability() {
    const optionContainers = Array.from(this.querySelectorAll('[data-option-parent]'));
    if (optionContainers.length >= 2) {
      this.updateVariantAvailability();
    }
  }

  updateVariantAvailability() {
    const variants = this.productData.variants;
    if (!variants) return;
    const selectedOptions = this.selectedOptionValues;
    if (!selectedOptions) return;

    const optionContainers = Array.from(this.querySelectorAll('[data-option-parent]'));
    optionContainers.forEach((container, optionIndex) => {
      const radioInputs = container.querySelectorAll('input[type="radio"]');
      if (radioInputs.length > 0) {
        this.updateRadioInputsAvailability(radioInputs, variants, selectedOptions, optionIndex);
      }
    });
  }

  updateRadioInputsAvailability(inputs, variants, selectedOptions, currentOptionIndex) {
    inputs.forEach(input => {
      const optionValue = input.value;
      const { exists, isAvailable } = this.checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue);
      const swatchLi = input.closest('li');
      this.updateOptionVisibility(input, swatchLi, exists, isAvailable, currentOptionIndex);
    });
  }

  checkVariantAvailability(variants, selectedOptions, currentOptionIndex, optionValue) {
    const exists = variants.some(variant => {
      return variant.options[currentOptionIndex] === optionValue && this.matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex);
    });
    const isAvailable = variants.some(variant => {
      return variant.available && variant.options[currentOptionIndex] === optionValue && this.matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex);
    });
    return { exists, isAvailable };
  }

  updateOptionVisibility(input, container, exists, isAvailable, optionIndex) {
    const optionParent = container ? container.closest('[data-option-parent]') : null;
    const isColorOption = optionParent ? optionParent.querySelector('.color-swatch') !== null : (optionIndex === 0);
    if (isColorOption) {
      if (container) container.style.display = '';
      this.updateDisabledState(input, isAvailable);
    } else {
      if (exists) {
        if (container) container.style.display = '';
        this.updateDisabledState(input, isAvailable);
      } else {
        if (container) container.style.display = 'none';
      }
    }
  }

  updateDisabledState(input, isAvailable) {
    if (isAvailable) {
      input.classList.remove('disabled');
    } else {
      input.classList.add('disabled');
    }
  }

  matchesOtherSelectedOptions(variant, selectedOptions, currentOptionIndex) {
    return selectedOptions.every((selectedOption, index) => {
      if (index === currentOptionIndex) return true;
      if (!selectedOption || selectedOption === '') return true;
      return variant.options[index] === selectedOption;
    });
  }

  get selectedOptionValues() {
    const optionContainers = Array.from(this.querySelectorAll('[data-option-parent]'));
    return optionContainers.map(container => {
      const checkedInput = container.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : '';
    });
  }

});
document.addEventListener('DOMContentLoaded', () => {
  if(document.body.classList.contains('template-product')){
  document.addEventListener('click', (evt) => {
    // If the click is NOT on or inside a complementary-variant-select element
    if (!evt.target.closest('.complementary-product-card')) {
      const complementaryVariantSelects = document.querySelectorAll('.complementary-variant-select__content.active');
      const dataAddToCart = document.querySelectorAll('[data-add-to-cart]');
      if(dataAddToCart.length > 0){
        dataAddToCart.forEach(el => {
          if(!el.classList.contains('only-default-variant-button')){
            el.classList.add('d-none');
          }
        });
      }
      const dataSelectOptions = document.querySelectorAll('[data-select-options]');
      if(dataSelectOptions.length > 0){
        dataSelectOptions.forEach(el => {
          if(!el.classList.contains('only-default-variant-select-button')){
            el.classList.remove('d-none');
          }
        });
      }
      if(complementaryVariantSelects.length > 0){
        complementaryVariantSelects.forEach(el => {
          el.classList.remove('active');

        });
      }
    }
  });
  }
})